<div class="dashboard-page">

  <!-- Page Header -->
  <div class="dashboard-header">
    <div>
      <h1>Dashboard</h1>
      <p>Welcome back! Here's your learning overview.</p>
    </div>
  </div>

  <!-- Statistics -->
  <div class="stats-grid">
    <div class="stat-card" *ngFor="let stat of filteredStats()">
      <div class="stat-top">
        <div class="stat-icon" [ngClass]="stat.color">
          <i class="bi" [ngClass]="stat.icon"></i>
        </div>
      </div>

      <div class="stat-value">{{ stat.value() }}</div>
      <div class="stat-title">{{ stat.title }}</div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="dashboard-content">

    <!-- Frequently Asked Questions -->
    <section class="dashboard-card courses-card">
      <div class="section-header">
        <div>
          <h2>Frequently Asked Questions</h2>
          <p>Questions employees are asking most often.</p>
        </div>

        <!-- <button class="text-button" type="button" (click)="onViewCourses()">
          View all <i class="bi bi-arrow-right"></i>
        </button> -->
      </div>

      <div class="course-list">
        <ng-container *ngIf="recentQuestions().length > 0; else noQuestions">

          <div class="course-item" *ngFor="let question of recentQuestions(); let i = index">

            <div class="course-icon primary">
              <i class="bi bi-chat-left-text"></i>
            </div>

            <div class="course-details">
              <div class="course-heading">
                <div>
                  <h3>{{ question.question }}</h3>
                </div>

                <span class="progress-label" *ngIf="question.percentage !== undefined">
                  {{ question.percentage }}%
                </span>
              </div>

              <div class="progress-track" *ngIf="question.percentage !== undefined">
                <div class="progress-bar" [ngClass]="getProgressClass(question.percentage)"
                  [style.width.%]="question.percentage">
                </div>
              </div>
            </div>
          </div>

        </ng-container>

        <ng-template #noQuestions>
          <div class="empty-state">
            <i class="bi bi-chat-square-text"></i>
            <p>No frequently asked questions available.</p>
          </div>
        </ng-template>
      </div>
    </section>

    <!-- Upload Documents -->
    <div class="upload-content">
      <div class="section-header">
        <div>
          <h2>Recently Uploaded Documents</h2>
          <p>View your latest uploaded documents</p>
        </div>
      </div>

      <div class="document-list" *ngIf="documents().length > 0; else noDocuments">
        <div class="document-item" *ngFor="let document of documents()">
          <div class="document-icon">
            <i class="bi bi-file-earmark-text"></i>
          </div>

          <div class="document-details">
            <h3>{{ document.message || 'Untitled Document' }}</h3>

            <p>
              <i class="bi bi-clock"></i>
              Uploaded:
              {{ document.createdAt | date: 'dd MMM yyyy, hh:mm a' }}
            </p>
          </div>
        </div>
      </div>

      <ng-template #noDocuments>
        <div class="empty-state">
          <i class="bi bi-folder2-open"></i>
          <p>No documents uploaded yet.</p>
        </div>
      </ng-template>
    </div>

  </div>
</div>